/**
 * Web wrapper around @wg/api/catalog — same client + same types as RN.
 */
import { createCatalogApi } from '@wg/api/catalog';
import { httpClient } from '../http';

const api = createCatalogApi(httpClient);

export default api;
export const catalogApi = api;
